import React from 'react';

const StudentRow = ({student:{name, rank, totalMark, totalAssignmentMark, totalQuizMark}}) => {
    return (
        <tr className="border-b border-slate-600/50">
        <td className="table-td text-center">{rank}</td>
        <td className="table-td text-center">{name}</td>
        <td className="table-td text-center">{totalQuizMark}</td>
        <td className="table-td text-center">{totalAssignmentMark}</td>
        <td className="table-td text-center">{totalMark}</td>
    </tr>
    );
};

export default StudentRow;